import React, { useState } from "react";
import Logo from "../../assets/logo.png";
import "./Header.css";
import bar from "../../assets/bars.png";
import { Link } from "react-scroll";
const Header = () => {
  const mobile = window.innerWidth <= 768 ? true : false;
  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <div className="header">
      <img src={Logo} alt="" className="logo" />

      {mobile === true && menuOpened === false ? (
        <div
          onClick={() => {
            setMenuOpened(true);
          }}
          style={{ backgroundColor: "var(--appColor)", padding: "0.5rem" }}
        >
          <img style={{ width: "1.5rem", height: "1.5rem" }} src={bar} alt="" />
        </div>
      ) : (
        <ul className="header-menu">
          <li>
            <Link
              onClick={() => {
                setMenuOpened(false);
              }}
              activeClass="hero"
              spy={true}
              smooth={true}
              to="hero-div"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                setMenuOpened(false);
              }}
              spy={true}
              smooth={true}
              to="programs"
            >
              Programs
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                setMenuOpened(false);
              }}
              spy={true}
              smooth={true}
              to="reasons"
            >
              Why us
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                setMenuOpened(false);
              }}
              spy={true}
              smooth={true}
              to="plans"
            >
              Plans
            </Link>
          </li>
          <li>
            <Link
              onClick={() => {
                setMenuOpened(false);
              }}
              spy={true}
              smooth={true}
              to="testimonial"
            >
              Testimonials
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Header;
